import type { OrgKind } from '@construction/shared';

type Tree = { [key: string]: string | Tree };

/**
 * 部署模式换文案（CR-073）。
 *
 * 同一套「单位」在两种部署里叫法不同：几家公司共用一套时叫「公司 / 平台」，
 * 单独部署给一家大公司时叫「分公司 / 总部」。行为完全一样，只有字不一样。
 *
 * 语言文件的正文按「公司」写；每份语言文件里的 `orgBranch` 是一棵**和正文同形**的小树，
 * 只放要换字的那几条。这里算出该往 i18next 里合并的那棵：`branch` 取 `orgBranch` 里的，
 * `company` 取正文里的原值（换回去用，本地开发来回切 ORG_KIND 时不会卡在上一种说法上）。
 *
 * 用覆盖而不是插值：插值要每个 `t()` 都记得传「公司」这个词，漏一处界面上就是裸的 `{{org}}`；
 * 覆盖漏一条最多是那句话还说「公司」。`org-wording.test.ts` 查两件事：覆盖的 key 正文里都有，
 * 正文里提到「公司 / 平台」的每一条都有分公司版。
 */
export function orgWording(base: Tree, kind: OrgKind): Tree {
  const overlay = base.orgBranch;
  if (!overlay || typeof overlay === 'string') return {};
  const walk = (over: Tree, root: string | Tree | undefined): Tree =>
    Object.fromEntries(
      Object.entries(over).map(([key, value]) => {
        const original = typeof root === 'object' ? root[key] : undefined;
        if (typeof value === 'string') {
          return [key, kind === 'branch' ? value : typeof original === 'string' ? original : value];
        }
        return [key, walk(value, original)];
      }),
    );
  return walk(overlay, base);
}
